/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ProfileDto {
  /**
   * Nazwa firmy lub imię i nazwisko
   * @example "Testowy Michał"
   */
  profileName: string;
  /**
   * Email
   * @example "test@test.pl"
   */
  profileEmail: string;
  /**
   * Numer telefonu
   * @example "123456789"
   */
  profilePhone: string;
  /**
   * Opis
   * @example "Opis testowy"
   */
  description?: string;
  /**
   * Zdjęcie użytkownika
   * @example "35trfgr5435.webp"
   */
  userPhoto?: string;
}

export interface ChangeNotificationDto {
  /**
   * Adres email do powiadomień użytkownika
   * @example "jan.kowalski@example.com"
   */
  notificationEmail: string;
  /**
   * Numer telefonu do powiadomień użytkownika
   * @example "48123456789"
   */
  notificationPhone: string;
}

export interface CreateOpinionDto {
  /**
   * Typ opinii
   * @example "CHAT_BOT"
   */
  opinionType: CreateOpinionDtoOpinionTypeEnum;
  /**
   * Tekst opinii
   * @example "Bardzo pomocny chatbot"
   */
  opinionText: string;
  /**
   * Ocena
   * @format int32
   * @min 1
   * @max 10
   * @example 5
   */
  rating: number;
}

export interface PasswordRestoreRequestDto {
  email: string;
}

export interface CreateAccountDto {
  /**
   * Email
   * @example "email@gmail.com"
   */
  email: string;
  /**
   * Password
   * @minLength 8
   * @maxLength 2147483647
   * @example "password"
   */
  password: string;
  /**
   * Confirm password
   * @minLength 8
   * @maxLength 2147483647
   * @example "password"
   */
  confirmPassword: string;
  /**
   * Imię
   * @example "Jan"
   */
  firstName: string;
  /**
   * Nazwisko
   * @example "Kowalski"
   */
  lastName: string;
  /**
   * Nazwa firmy
   * @example "Inwestoro"
   */
  companyName?: string;
  /**
   * Numer telefonu
   * @example "+48123456789"
   */
  phoneNumber: string;
}

export interface PasswordLinkChangeDto {
  /**
   * Password
   * @minLength 8
   * @maxLength 2147483647
   * @example "newPassword"
   */
  password: string;
  /**
   * Confirm password
   * @minLength 8
   * @maxLength 2147483647
   * @example "newPassword"
   */
  confirmPassword: string;
  token: string;
}

export interface PasswordChangeDto {
  /**
   * Password
   * @minLength 8
   * @maxLength 2147483647
   * @example "newPassword"
   */
  password: string;
  /**
   * Confirm password
   * @minLength 8
   * @maxLength 2147483647
   * @example "newPassword"
   */
  confirmPassword: string;
  /**
   * Old password
   * @minLength 8
   * @maxLength 2147483647
   * @example "oldPassword"
   */
  oldPassword: string;
}

export interface UserResourcesDto {
  /**
   * Ilość dostępnych SMS
   * @format int32
   * @example 75
   */
  totalAvailableSms: number;
  /**
   * Całkowita ilość wszystkich SMS w pakiecie
   * @format int32
   * @example 150
   */
  totalSmsPackage: number;
  /**
   * Całkowita ilość dostępnych tokenów AI
   * @format int32
   * @example 350000
   */
  totalAvailableAiTokens: number;
  /**
   * Ilość wszystkich tokenów AI w pakiecie
   * @format int32
   * @example 1000000
   */
  totalAiTokensPackage: number;
}

export interface MyDataDto {
  /**
   * UUID profilu użytkownika
   * @format uuid
   */
  profileUuid: string;
  /**
   * Pełne imię użytkownika
   * @example "Jan Kowalski"
   */
  name: string;
  /**
   * Adres e-mail użytkownika
   * @example "jan.kowalski@example.com"
   */
  email: string;
  /**
   * Nazwa firmy lub imię i nazwisko
   * @example "Testowy Michał"
   */
  profileName?: string;
  /**
   * Email
   * @example "test@test.pl"
   */
  profileEmail?: string;
  /**
   * Numer telefonu
   * @example "123456789"
   */
  profilePhone?: string;
  /**
   * Opis
   * @example "Opis testowy"
   */
  description?: string;
  /**
   * Zdjęcie użytkownika
   * @example "35trfgr5435.webp"
   */
  userPhoto?: string;
}

export interface NotificationInfoDto {
  /**
   * Liczba dostępnych SMS w danym miesiącu
   * @example "10/100"
   */
  monthSmsToUse: string;
  /**
   * Liczba dostępnych SMS w danym miesiącu
   * Kupione + dostępne SMS / pakiet SMS
   * @example "200/100"
   */
  totalMonthSmsToUse: string;
  /**
   * Liczba SMS kupionych
   * @format int32
   * @example 100
   */
  boughtSms: number;
  /**
   * Pakiet SMS
   * @format int32
   * @example 100
   */
  smsPackage: number;
  /**
   * Liczba SMS do użycia w pakiecie
   * @format int32
   * @example 10
   */
  smsToUsed: number;
  /**
   * Liczba SMS do wykorzystania w dniu
   * @format int32
   * @example 100
   */
  smsDayLimit: number;
  /**
   * Data resetu SMS
   * @format date-time
   */
  smsDayReset?: string;
  /**
   * Czy aktywne powiadomienia
   * @example true
   */
  activeNotification: boolean;
  /**
   * Czy aktywne powiadomienia push
   * @example true
   */
  pushNotification: boolean;
  /**
   * Adres email do powiadomień użytkownika
   * @example "jan.kowalski@example.com"
   */
  notificationEmail: string;
  /**
   * Numer telefonu do powiadomień użytkownika
   * @example "48123456789"
   */
  notificationPhone: string;
}

export interface AiTokenDto {
  /**
   * Liczba dostępnych tokenów AI w danym miesiącu
   * @example "10000/500000"
   */
  monthAiTokensToUse: string;
  /**
   * Liczba tokenów AI w pakiecie
   * @format int32
   * @example 500000
   */
  aiTokenPackage: number;
  /**
   * Liczba tokenów AI kupionych
   * @format int32
   * @example 100
   */
  boughtAiToken: number;
  /**
   * Liczba dostępnych tokenów AI w pakiecie
   * @format int32
   * @example 10000
   */
  availableAiTokens: number;
  /**
   * Data resetu tokenów AI
   * @format date-time
   */
  aiTokenReset: string;
}

export interface ActivePackageDto {
  /**
   * Nazwa pakietu
   * @example "Skaner okazji MAX"
   */
  packageName?: string;
  /**
   * Data rozpoczęcia pakietu
   * @format date-time
   */
  startDate?: string;
  /**
   * Data zakończenia pakietu
   * @format date-time
   */
  endDate?: string;
  /**
   * Czas do końca pakietu w dniach
   * @format int32
   * @example 30
   */
  daysToEnd: number;
}

/**
 * Typ opinii
 * @example "CHAT_BOT"
 */
export enum CreateOpinionDtoOpinionTypeEnum {
  CHAT_BOT = "CHAT_BOT",
}

export enum EditPushNotificationTokenParamsAppTypeEnum {
  ANDROID = "ANDROID",
  IOS = "IOS",
  WEB = "WEB",
}

export enum CheckOpinionParamsOpinionTypeEnum {
  CHAT_BOT = "CHAT_BOT",
}

/**
 * Platforma mobilna (ANDROID lub IOS)
 * @example "ANDROID"
 */
export enum CheckVersionParamsPlatformEnum {
  ANDROID = "ANDROID",
  IOS = "IOS",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://192.168.31.12:8080";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://192.168.31.12:8080
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  user = {
    /**
     * @description Nowa nazwa zdjęcia spowoduje zastąpienie starego zdjęcia nowym, a brak usunie stare jeżeli istniało i zostawi je puste.
     *
     * @tags Moje dane
     * @name UpdateMyProfile
     * @summary Aktualizacja profilu
     * @request PUT:/user/profile/update
     * @secure
     */
    updateMyProfile: (data: ProfileDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/user/profile/update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Powiadomienia
     * @name EditPushNotification
     * @summary Edycja powiadomień PUSH
     * @request PUT:/user/notification/edit/push-notification
     * @secure
     */
    editPushNotification: (
      query?: {
        /** @default true */
        activeStatus?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/user/notification/edit/push-notification`,
        method: "PUT",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Powiadomienia
     * @name EditPushNotificationToken
     * @summary Edycja tokenu do powiadomień push w aplikacjach WEB/Android/iOS
     * @request PUT:/user/notification/edit/push-notification/token
     * @secure
     */
    editPushNotificationToken: (
      query: {
        appToken: string;
        appType: EditPushNotificationTokenParamsAppTypeEnum;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/user/notification/edit/push-notification/token`,
        method: "PUT",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Powiadomienia
     * @name UpdateNotificationMethod
     * @summary Aktualizacja danych kontaktowych do powiadomień
     * @request PUT:/user/notification/edit/notification
     * @secure
     */
    updateNotificationMethod: (data: ChangeNotificationDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/user/notification/edit/notification`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Powiadomienia
     * @name EditDaySmsLimit
     * @summary Edycja dziennego limitu SMS
     * @request PUT:/user/notification/edit/day-limit
     * @secure
     */
    editDaySmsLimit: (
      query?: {
        /**
         * @format int32
         * @default 20
         */
        dayLimit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/user/notification/edit/day-limit`,
        method: "PUT",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Powiadomienia
     * @name EditActiveNotificationStatus
     * @summary Edycja aktywacji powiadomień email i SMS
     * @request PUT:/user/notification/edit/active-notification
     * @secure
     */
    editActiveNotificationStatus: (
      query?: {
        /** @default true */
        activeStatus?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/user/notification/edit/active-notification`,
        method: "PUT",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Dostępne formaty: JPG, JPEG, PNG, WEBP, TIFF, BMP, GIF
     *
     * @tags Moje dane
     * @name CreateProfilePhoto
     * @summary Tworzenie zdjęć podczas dodawania ogłoszenia.
     * @request POST:/user/profile/image/create
     * @secure
     */
    createProfilePhoto: (
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/user/profile/image/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * @description Przesyłanie opinii o różnych modułach przez użytkownika
     *
     * @tags Operacje związane z opiniami
     * @name SendOpinion
     * @summary Przesyłanie opinii o modułach
     * @request POST:/user/opinion/send
     * @secure
     */
    sendOpinion: (data: CreateOpinionDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/user/opinion/send`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Logowanie błędów ze strony aplikacji na froncie
     * @name LogMessage
     * @summary Logowanie błędów ze strony aplikacji na froncie
     * @request POST:/user/log-error
     * @secure
     */
    logMessage: (data: Record<string, string>, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/user/log-error`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Pozwala użytkownikowi rozpocząć proces przywracania hasła poprzez wysłanie wiadomości e-mail z unikalnym linkiem.
     *
     * @tags Podstawowe zarządzanie kontem użytkownika
     * @name SendPasswordRestoreLink
     * @summary Wysyła link do zresetowania hasła
     * @request POST:/user/account/link/restore-password
     * @secure
     */
    sendPasswordRestoreLink: (data: PasswordRestoreRequestDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/user/account/link/restore-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podstawowe zarządzanie kontem użytkownika
     * @name CreateAccount
     * @summary Tworzenie konta użytkownika
     * @request POST:/user/account/create
     * @secure
     */
    createAccount: (data: CreateAccountDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/user/account/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Pozwala użytkownikowi ustawić nowe hasło po kliknięciu w link wysłany na e-mail
     *
     * @tags Podstawowe zarządzanie kontem użytkownika
     * @name ChangePasswordByLink
     * @summary Zmiana hasła przy użyciu linku resetującego
     * @request PATCH:/user/account/link/reset-password
     * @secure
     */
    changePasswordByLink: (data: PasswordLinkChangeDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/user/account/link/reset-password`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Pozwala zalogowanemu użytkownikowi zmienić swoje hasło
     *
     * @tags Podstawowe zarządzanie kontem użytkownika
     * @name ChangePassword
     * @summary Zmiana hasła użytkownika
     * @request PATCH:/user/account/change-password
     * @secure
     */
    changePassword: (data: PasswordChangeDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/user/account/change-password`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Metoda służy do wyszukiwania informacji o zasobach użytkownika na podstawie jego id, które jest pobierane z tokena JWT. W odpowiedzi zwracane są informacje o zasobach użytkownika.
     *
     * @tags Zasoby użytkownika
     * @name GetUserResources
     * @summary Wyszukiwanie informacji o zasobach użytkownika
     * @request GET:/user/resources/info
     * @secure
     */
    getUserResources: (params: RequestParams = {}) =>
      this.http.request<UserResourcesDto, object>({
        path: `/user/resources/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Moje dane
     * @name FindUserDataInformation
     * @summary Pobieranie informacji dla zakładki moje dane
     * @request GET:/user/profile/info
     * @secure
     */
    findUserDataInformation: (params: RequestParams = {}) =>
      this.http.request<MyDataDto, object>({
        path: `/user/profile/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Moje dane
     * @name ExistProfile
     * @summary Sprawdzanie czy profil jest aktywowany
     * @request GET:/user/profile/activation-status
     * @secure
     */
    existProfile: (params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/user/profile/activation-status`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Sprawdzenie, czy użytkownik ma opinię o danym module
     *
     * @tags Operacje związane z opiniami
     * @name CheckOpinion
     * @summary Sprawdzenie opinii użytkownika
     * @request GET:/user/opinion/check
     * @secure
     */
    checkOpinion: (
      query: {
        opinionType: CheckOpinionParamsOpinionTypeEnum;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/user/opinion/check`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Powiadomienia
     * @name ActivePackageInfo
     * @summary Wyszukiwanie szczegółów powiadomień
     * @request GET:/user/notification/info
     * @secure
     */
    activePackageInfo: (params: RequestParams = {}) =>
      this.http.request<NotificationInfoDto, object>({
        path: `/user/notification/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Porównuje wersję aplikacji (app_version) z konfiguracją w bazie danych. Wersje muszą być w formacie Semantic Versioning: MAJOR.MINOR.PATCH (np. '2.1.0'). Porównanie jest NUMERYCZNE — '1.10.0' jest poprawnie nowsza niż '1.2.0'. Logika: app_version < min_required_version → UPDATE_REQUIRED; app_version >= min_required_version i < latest_version → UPDATE_AVAILABLE; app_version >= latest_version → OK. WAŻNE: Po wrzuceniu nowej wersji do sklepu, daj 24-48h zanim ustawisz min_required_version — sklepy mają opóźnienie w publikacji.
     *
     * @tags Konfiguracja aplikacji mobilnej
     * @name CheckVersion
     * @summary Sprawdzenie wersji aplikacji mobilnej
     * @request GET:/user/mobile-config/check-version
     * @secure
     */
    checkVersion: (
      query: {
        /**
         * Platforma mobilna (ANDROID lub IOS)
         * @example "ANDROID"
         */
        platform: CheckVersionParamsPlatformEnum;
        /**
         * Aktualna wersja aplikacji na urządzeniu w formacie Semantic Versioning (MAJOR.MINOR.PATCH)
         * @example "1.4.2"
         */
        app_version: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/user/mobile-config/check-version`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie pakiem tokenów AI
     * @name AiTokenInfo
     * @summary Pobieranie danych o pakiecie tokenów AI użytkownika
     * @request GET:/user/ai-token/info
     * @secure
     */
    aiTokenInfo: (params: RequestParams = {}) =>
      this.http.request<AiTokenDto, object>({
        path: `/user/ai-token/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Aktywne pakiety
     * @name ActivePackageInfo1
     * @summary Pobieranie danych na temat aktywnego pakietu
     * @request GET:/user/active-package/info
     * @secure
     */
    activePackageInfo1: (params: RequestParams = {}) =>
      this.http.request<ActivePackageDto, object>({
        path: `/user/active-package/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podstawowe zarządzanie kontem użytkownika
     * @name DeleteAccount
     * @summary Usuwanie konta użytkownika
     * @request DELETE:/user/account/delete
     * @secure
     */
    deleteAccount: (params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/user/account/delete`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
}
